import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import el from './locales/el.json';
import en from './locales/en.json';
import { DEFAULT_APP_LANGUAGE, SUPPORTED_LANGUAGES } from './supportedLanguages';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      el: { translation: el },
    },

    fallbackLng: DEFAULT_APP_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false,
    },

    returnNull: false,
    returnEmptyString: false,

    react: {
      useSuspense: false,
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'app_language',
    },
  });

export default i18n;
